import { tariffUrls } from '@/configs/endpoints'
import { internetIconByTpId } from '@/configs/constants'
import { getLocaleKey } from '@/configs/utils'
import api from '@/plugins/api'
import { SUCCESS_CODES } from '@/configs/constants'

export default {
  state: () => ({
    tariffs: [],
    isLoading: false,
    internet: null
  }),
  mutations: {
    SET_DATA_TARIFFS(state, data) {
      Object.entries(data).forEach(entry => {
        state[entry[0]] = entry[1]
      })
    }
  },
  actions: {
    async getTariffs({ commit }) {
      try {
        commit('SET_DATA_TARIFFS', { isLoading: true })

        const response = await api.get(tariffUrls.internet_all)

        if (response?.code !== 200) return

        const tariffs = response.data.map(tariff => ({
          ...tariff,
          icon: internetIconByTpId[tariff.tp_id] || internetIconByTpId.default
        }))
        commit('SET_DATA_TARIFFS', { tariffs })
      } catch (error) {
        console.error('Failed to get tariffs:', error)
      } finally {
        commit('SET_DATA_TARIFFS', { isLoading: false })
      }
    },
    async setIP() {
      const response = await api.post(tariffUrls.realip)
      return response.data
    },
    async deleteIP() {
      const response = await api.delete(tariffUrls.realip)
      return response.data
    },
    async freezeAccount(_, payload) {
      const [date_start, date_end] = payload

      const response = await api.post(tariffUrls.freeze, {
        body: { date_start, date_end }
      })
      return response.data
    },
    async unfreezeAccount() {
      const response = await api.delete(tariffUrls.freeze)
      return response.data
    },
    async postTariff(context, payload) {
      const response = await api.post(tariffUrls.change_tarif, { body: payload })
      return response.data
    },

    async sendRequestToConnectInternet(_, payload) {
      const response = await api.post(tariffUrls.connect_request, { body: payload })
      return response.data
    },

    async getInternetTariffsInfo({ commit }) {
      try {
        const response = await api.get(tariffUrls.internet)
        if (SUCCESS_CODES.includes(response.code)) {
          commit('SET_DATA_TARIFFS', { internet: response.data })
        }
        return response
      } catch (error) {
        console.error('Failed to get internet tariff info:', error)
      }
    }
  },
  getters: {
    connectableTariffs: state => state.tariffs.filter(tariff => tariff.is_active !== false),
    currentTariff: state => {
      const tpId = state.internet?.tp_id
      if (tpId == null) return undefined
      return state.tariffs.find(tariff => tariff.tp_id === tpId)
    },
    getTariffName: (state, getters) => {
      if (!getters.currentTariff) return ''
      return getLocaleKey(getters.currentTariff, 'name')
    },
    internetStatus: state => state.internet?.internet_status ?? null,
    internetReduction: state => state.internet?.reduction ?? 0
  }
}
